const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://arngkzw41l.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://b9alvkuz3e.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.demo.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.demo.forwoodsafety.com'
  }
};

export default config;